var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tsos-tooltip"},[_c('a-tooltip',{attrs:{"placement":"right"}},[_c('template',{slot:"title"},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")]),_c('a-icon',{style:({color: '#3A0BA3'}),attrs:{"type":"info-circle"}})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }